import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/address/importer/addressImporterActions'

export default importerReducers(actions)
